<div class="content-wrapper">
    <br>
    <table class="feature-mainTable" width="95%">
        <tbody>
            <tr>
                <td>
                    {{'To filter the Deliverable list by vehicle line'|translate}}, {{'select here'|translate}}&nbsp;
                    <select class="vehicleLine" [(ngModel)]="vehicleLine" #setvehicleLine (change)="onSetVehLang()">
                        <option value="None" selected="selected">{{'None'|translate}}</option>
                        <option *ngFor="let vehicleLine of vehList" [ngValue]="vehicleLine">
                            {{vehicleLine}}
                        </option>
                    </select>
                    {{'Language'|translate}}&nbsp;
                    <select class="language" [(ngModel)]="language" #setlanguage (change)="onSetVehLang()">
                        <option value="bg">{{'bg'|translate}}</option>
                        <option value="zh">{{'zh'|translate}}</option>
                        <option value="hr">{{'hr'|translate}}</option>
                        <option value="cs">{{'cs'|translate}}</option>
                        <option value="da">{{'da'|translate}}</option>
                        <option value="nl">{{'nl'|translate}}</option>
                        <option value="en" selected="selected">{{'en'|translate}}</option>
                        <option value="et">{{'et'|translate}}</option>
                        <option value="fi">{{'fi'|translate}}</option>
                        <option value="fr">{{'fr'|translate}}</option>
                        <option value="de">{{'de'|translate}}</option>
                        <option value="el">{{'el'|translate}}</option>
                        <option value="hu">{{'hu'|translate}}</option>
                        <option value="it">{{'it'|translate}}</option>
                        <option value="ja">{{'ja'|translate}}</option>
                        <option value="lv">{{'lv'|translate}}</option>
                        <option value="lt">{{'lt'|translate}}</option>
                        <option value="no">{{'no'|translate}}</option>
                        <option value="pl">{{'pl'|translate}}</option>
                        <option value="pt">{{'pt'|translate}}</option>
                        <option value="ro">{{'ro'|translate}}</option>
                        <option value="ru">{{'ru'|translate}}</option>
                        <option value="sr">{{'sr'|translate}}</option>
                        <option value="sk">{{'sk'|translate}}</option>
                        <option value="sl">{{'sl'|translate}}</option>
                        <option value="es">{{'es'|translate}}</option>
                        <option value="sv">{{'sv'|translate}}</option>
                        <option value="tr">{{'tr'|translate}}</option>
                        <option value="uk">{{'uk'|translate}}</option>
                    </select>
                </td>
            </tr>
        </tbody>
    </table>
    <div *ngIf="showloadingfeaturemap" class="loader-feature">
        <img id="loadSpinnerImg" src="assets/images/ajax-loader.gif" width="30" height="30" class="imgNoBorder-adhoc">
    </div>
    <div *ngIf="!onselecting && !showloadingfeaturemap" class="feature-mainTable" width="90%">
        <span>{{'No vehicle line has been selected'|translate}}.</span>
    </div>
    <div *ngIf="nodataerror && !showloadingfeaturemap" class="feature-mainTable" width="90%">
        <span>{{'No mappings have been found for vehicle line and language'|translate}}.</span>
    </div>
    <table *ngIf="onselecting && !showloadingfeaturemap && !nodataerror" class="feature-mainTable" width="95%">
        <tbody>
            <tr>
                <td colspan="7">&nbsp;<br></td>
            </tr>
            <tr>
                <td class="prompt-vehiceLine">{{'Code Type'|translate}}</td>
                <td class="prompt-vehiceLine">{{'Code Value'|translate}}</td>
                <td class="prompt-vehiceLine">{{'Variant ID'|translate}}</td>
                <td class="prompt-vehiceLine">{{'Deliverable Type'|translate}}</td>
                <td class="prompt-vehiceLine">{{'Language Code'|translate}}</td>
                <td class="prompt-vehiceLine">{{'Country Code'|translate}}</td>
                <td class="prompt-vehiceLine">{{'Display name'|translate}}</td>
            </tr>
            <tr *ngFor="let feat of featureDeliverMapList;let j=index" class="veh-bgcolor">
                <td class="veh-align">{{feat.codetype}}</td>
                <td class="veh-align">{{feat.codeValue}}</td>
                <td class="veh-align">{{feat.deliverableId}}</td>
                <td class="veh-align">{{feat.deliverableType}}</td>
                <td class="veh-align">{{feat.languageCode}}</td>
                <td class="veh-align">{{feat.countryCode}}</td>
                <td class="veh-align">
                    <select class="displayName" name="displayName" [(ngModel)]="feat.displayName" #setdisplayName
                        (change)="onSelectDispName(setdisplayName.value,j)">
                        <option value="null">--- {{'No Name Selected'|translate}} ---</option>
                        <option *ngFor="let i of modelnamelist" [value]="i.id">{{i.name}}[{{i.id}}]
                        </option>
                    </select>&nbsp;
                    <input type="submit" value="{{'Update'|translate}}" (click)="onClickOfUpdate(feat.id)">
                </td>
            </tr>
        </tbody>
    </table>
</div>